/* src/main/webapp/app/app.component.scss */
/*# sourceMappingURL=app.component-SE2MDEVN.css.map */
